export default __webpack_public_path__ + "static/media/folder.0344f2d0.svg";